import { useState } from 'react'
import { ArrowRight } from '@phosphor-icons/react'
import { ORIGINS, PACKAGES, TOURS, TRIP_TYPES, whatsappLink } from '../data/travel'

const fieldClass =
  'w-full rounded-xl border border-navy-900/10 bg-white px-4 py-3 text-base text-navy-950 outline-none transition-colors focus:border-sunset-500'
const labelClass = 'text-xs font-semibold uppercase tracking-wide text-navy-700/50'

export default function QuoteWidget() {
  const [type, setType] = useState(TRIP_TYPES[0])
  const [sent, setSent] = useState(false)

  function onSubmit(e) {
    e.preventDefault()
    const data = new FormData(e.currentTarget)
    const lines = [
      'Hola, quiero cotizar un viaje.',
      `Tipo: ${type}`,
      `Origen: ${data.get('origin')}`,
      `Destino: ${data.get('destination')}`,
      `Salida: ${data.get('depart')}`,
      `Regreso: ${data.get('return') || 'por definir'}`,
      `Pasajeros: ${data.get('passengers')}`,
    ]
    window.open(whatsappLink(lines.join('\n')), '_blank', 'noopener,noreferrer')
    setSent(true)
  }

  return (
    <form
      id="cotizador"
      onSubmit={onSubmit}
      className="scroll-mt-24 rounded-2xl bg-white p-5 text-navy-950 shadow-[0_24px_60px_rgba(14,20,32,0.18)] md:p-6"
    >
      <div role="tablist" aria-label="Tipo de viaje" className="mb-5 flex flex-wrap gap-2">
        {TRIP_TYPES.map((t) => (
          <button
            key={t}
            type="button"
            role="tab"
            aria-selected={type === t}
            onClick={() => setType(t)}
            className={`rounded-xl px-4 py-2 text-sm font-semibold transition-colors ${
              type === t ? 'bg-navy-950 text-white' : 'bg-sunset-50 text-navy-950 hover:bg-sunset-100'
            }`}
          >
            {t}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-[1.1fr_1.1fr_1fr_1fr_0.7fr]">
        <div className="flex flex-col gap-2">
          <label className={labelClass} htmlFor="origin">Origen</label>
          <select id="origin" name="origin" className={fieldClass} defaultValue={ORIGINS[0]}>
            {ORIGINS.map((o) => (
              <option key={o}>{o}</option>
            ))}
          </select>
        </div>
        <div className="flex flex-col gap-2">
          <label className={labelClass} htmlFor="destination">Destino</label>
          <input
            id="destination"
            name="destination"
            type="text"
            list="destination-suggestions"
            required
            placeholder="¿A dónde quieres ir?"
            autoComplete="off"
            className={fieldClass}
          />
          <datalist id="destination-suggestions">
            {TOURS.map((t) => (
              <option key={t.slug} value={`${t.title}, ${t.place}`} />
            ))}
            {PACKAGES.map((p) => (
              <option key={p.slug} value={`${p.name}, ${p.place}`} />
            ))}
          </datalist>
        </div>
        <div className="flex flex-col gap-2">
          <label className={labelClass} htmlFor="depart">Salida</label>
          <input id="depart" name="depart" type="date" required className={fieldClass} />
        </div>
        <div className="flex flex-col gap-2">
          <label className={labelClass} htmlFor="return">Regreso</label>
          <input id="return" name="return" type="date" className={fieldClass} />
        </div>
        <div className="flex flex-col gap-2">
          <label className={labelClass} htmlFor="passengers">Pasajeros</label>
          <select id="passengers" name="passengers" className={fieldClass} defaultValue="2">
            {Array.from({ length: 9 }, (_, i) => i + 1).map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-navy-700/50">
          Te respondemos por WhatsApp en menos de 24 horas, con opciones y precio final.
        </p>
        <button
          type="submit"
          className="group inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-sunset-500 px-6 py-3.5 text-sm font-semibold text-white transition-transform duration-150 hover:brightness-110 active:scale-[0.98]"
        >
          Pedir cotización
          <ArrowRight size={16} weight="bold" className="transition-transform duration-200 group-hover:translate-x-0.5" />
        </button>
      </div>
      {sent && (
        <p className="mt-3 text-sm text-navy-700/50">
          Abrimos WhatsApp en otra pestaña con tu solicitud. Solo falta que la envíes.
        </p>
      )}
    </form>
  )
}
